export default "__VITE_ASSET__BbmFD3Fo__"